export default __webpack_public_path__ + "static/festl-ruhpolding-preview-42873232f86dcb120e80a9907ea519e0.jpg";